module.exports = __webpack_public_path__ + "img/bigscoot.c8bf0ade.png";